export enum RenderRoot {
  root = "#root",
  modal = "#modal",
}

export const getRenderRoot = (root: RenderRoot): Element | null => {
  switch (root) {
    case RenderRoot.modal:
      return document.querySelector(RenderRoot.modal);
    default:
    case RenderRoot.root:
      return document.querySelector(RenderRoot.root);
  }
};
